import { accountTypeLabelMap } from 'maps/echeckMaps/echeckMaps';

/**
 * Retrieves the display label for an eCheck account type.
 *
 * Looks up the provided accountType in the accountTypeMap and returns the corresponding label.
 * If the accountType is not found, defaults to the label for 'CHECKING'.
 *
 * @param {string} accountType - The type of eCheck account (e.g., 'CHECKING', 'SAVINGS', etc.).
 * @returns {string} The display label for the eCheck account type.
 */
export const getEcheckAccountTypeLabel = ({ accountType }) =>
  accountTypeLabelMap[accountType] ?? accountTypeLabelMap['CHECKING'];
